module.exports = __webpack_public_path__ + "components/signup-page/static/surf-forecast_outside--header_logo-80260555ea1ca133b12757336c7a1081.webp";